module.exports = __webpack_public_path__ + "static/media/richmondLunch.0debf6dc.pdf";